import { Routes } from '@angular/router';
import { environment } from './../environments/environment';

export const routes: Routes = [
  {
    path: 'a',
    loadComponent: () => {
      if (environment.APP_VERSION == 'SonEspaceRefuge') return import('./homepage/homepage.page').then(m => m.HomepagePage);
      if (environment.APP_VERSION == 'SonEspacePension') return import('./homepagePension/homepage.page').then(m => m.HomepagePensionPage);
      return import('./homepageV2/homepage.page').then(m => m.HomepagePageV2);
    }
  },
  {
    path: '',
    loadComponent: () => {
      if (environment.APP_VERSION == 'SonEspaceRefuge') return import('./homepage/homepage.page').then(m => m.HomepagePage);
      if (environment.APP_VERSION == 'SonEspacePension') return import('./homepagePension/homepage.page').then(m => m.HomepagePensionPage);
      return import('./homepageV2/homepage.page').then(m => m.HomepagePageV2);
    }
  },
  {
    path: 'homepage',
    loadComponent: () => {
      if (environment.APP_VERSION == 'SonEspaceRefuge') return import('./homepage/homepage.page').then(m => m.HomepagePage);
      if (environment.APP_VERSION == 'SonEspacePension') return import('./homepagePension/homepage.page').then(m => m.HomepagePensionPage);
      return import('./homepageV2/homepage.page').then(m => m.HomepagePageV2);
    }
  },
  {
    path: 'homepage/post/:postId',
    loadComponent: () => {
      if (environment.APP_VERSION == 'SonEspaceRefuge') return import('./homepage/homepage.page').then(m => m.HomepagePage);
      if (environment.APP_VERSION == 'SonEspacePension') return import('./homepagePension/homepage.page').then(m => m.HomepagePensionPage);
      return import('./homepageV2/homepage.page').then(m => m.HomepagePageV2);
    }
  },
  {
    path: 'homepage/:segment',
    loadComponent: () => {
      if (environment.APP_VERSION == 'SonEspaceRefuge') return import('./homepage/homepage.page').then(m => m.HomepagePage);
      if (environment.APP_VERSION == 'SonEspacePension') return import('./homepagePension/homepage.page').then(m => m.HomepagePensionPage);
      return import('./homepageV2/homepage.page').then(m => m.HomepagePageV2);
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'user-profile-create/organization/:type',
    loadComponent: () => import('./userProfile/user-profile-create/user-profile-create.page').then(m => m.UserProfileCreatePage)
  },
  {
    path: 'user-profile-create',
    loadComponent: () => import('./userProfile/user-profile-create/user-profile-create.page').then(m => m.UserProfileCreatePage)
  },
  {
    path: 'user-profile-onboarding',
    loadComponent: () => import('./userProfile/user-profile-onboarding/user-profile-onboarding.page').then(m => m.UserProfileOnboardingPage)
  },
  {
    path: 'user-profile-update',
    loadComponent: () => import('./userProfile/user-profile-update/user-profile-update.page').then(m => m.UserProfileUpdatePage)
  },
  {
    path: 'password-lost',
    loadComponent: () => import('./password/password-lost/password-lost.page').then(m => m.PasswordLostPage)
  },
  {
    path: 'password-reset/:key',
    loadComponent: () => import('./password/password-reset/password-reset.page').then(m => m.PasswordResetPage)
  },
  environment.APP_VERSION == 'SonEspacePension' ? {
    path: 'animal-list',
    redirectTo: 'boarding-list',
    pathMatch: 'full'
  } : {
    path: 'animal-list',
    loadComponent: () => import('./animal/animal-list/animal-list.page').then(m => m.AnimalListPage)
  },
  {
    path: 'boarding-list',
    loadComponent: () => import('./boarding/boarding-list/boarding-list.page').then(m => m.BoardingListPage)
  },
  {
    path: 'boarding-add',
    loadComponent: () => import('./boarding/boarding-add/boarding-add.page').then(m => m.BoardingAddPage)
  },
  {
    path: 'boarding-owner-request/:boardingId',
    loadComponent: () => import('./boarding/boarding-owner-request/boarding-owner-request.page').then(m => m.BoardingOwnerRequestPage)
  },
  {
    path: 'boarding-pension-authorization/:identifier',
    loadComponent: () => import('./boarding/boarding-pension-authorization/boarding-pension-authorization.page').then(m => m.BoardingPensionAuthorizationPage)
  },

  {
    path: 'animal-update',
    loadComponent: () => import('./animal/animal-update/animal-update.page').then(m => m.AnimalUpdatePage)
  },
  {
    path: 'animal-update/:animalId',
    loadComponent: () => import('./animal/animal-update/animal-update.page').then(m => m.AnimalUpdatePage)
  },
  ['SonEspaceSante', 'SonEspaceEleveur', 'SonEspacePension'].includes(environment.APP_VERSION) ? {
    path: 'animal-add',
    loadComponent: () => import('./animal/animal-add/animal-add.page').then(m => m.AnimalAddPage)
  } : {
    path: 'animal-add',
    redirectTo: 'animal-update',
    pathMatch: 'full'
  },
  {
    path: 'event-list',
    loadComponent: () => import('./agenda/event-list/event-list.page').then(m => m.EventListPage)
  },
  {
    path: 'event-add/:type',
    loadComponent: () => import('./agenda/event-update/event-update.page').then(m => m.EventUpdatePage)
  },
  {
    path: 'event-add/:type/:defaultAnimalId',
    loadComponent: () => import('./agenda/event-update/event-update.page').then(m => m.EventUpdatePage)
  },
  {
    path: 'event-update',
    loadComponent: () => import('./agenda/event-update/event-update.page').then(m => m.EventUpdatePage)
  },
  {
    path: 'event-update/:eventId',
    loadComponent: () => import('./agenda/event-update/event-update.page').then(m => m.EventUpdatePage)
  },
  {
    path: 'event-report/:eventId',
    loadComponent: () => import('./agenda/event-report/event-report.page').then(m => m.EventReportPage)
  },
  {
    path: 'animal-fiche/:animalId',
    loadComponent: () => import('./animal/animal-fiche/animal-fiche.page').then(m => m.AnimalFichePage)
  },
  {
    path: 'animal-fiche/:animalId/:segment/:vaccineValenceId',
    loadComponent: () => import('./animal/animal-fiche/animal-fiche.page').then(m => m.AnimalFichePage)
  },
  {
    path: 'animal-fiche/:animalId/:segment',
    loadComponent: () => import('./animal/animal-fiche/animal-fiche.page').then(m => m.AnimalFichePage)
  },
  {
    path: 'activities/activity-history',
    loadComponent: () => import('./activities/activity-history/activity-history.page').then(m => m.ActivityHistoryPage)
  },
  {
    path: 'activities/activity-history/:animalId',
    loadComponent: () => import('./activities/activity-history/activity-history.page').then(m => m.ActivityHistoryPage)
  },
  {
    path: 'heart-rate',
    loadComponent: () => import('./heart-rate/heart-rate.page').then(m => m.HeartRatePage)
  },
  {
    path: 'mentions-legales',
    loadComponent: () => import('./mentions-legales/mentions-legales.page').then(m => m.MentionsLegalesPage)
  },
  {
    path: 'contact',
    loadComponent: () => import('./contact/contact.page').then(m => m.ContactPage)
  },
  {
    path: 'user-profile-delete',
    loadComponent: () => import('./userProfile/user-profile-delete/user-profile-delete.page').then(m => m.UserProfileDeletePage)
  },
  {
    path: 'clinic-contact-list',
    loadComponent: () => import('./clinic/clinic-contact-list/clinic-contact-list.page').then(m => m.ClinicContactListPage)
  },
  {
    path: 'clinic-contact-update/:clinicContactId',
    loadComponent: () => import('./clinic/clinic-contact-update/clinic-contact-update.page').then(m => m.ClinicContactUpdatePage)
  },
  {
    path: 'clinic-contact-update',
    loadComponent: () => import('./clinic/clinic-contact-update/clinic-contact-update.page').then(m => m.ClinicContactUpdatePage)
  },
  {
    path: 'clinic-map',
    loadComponent: () => import('./clinic/clinic-map/clinic-map.page').then(m => m.ClinicMapPage)
  },
  {
    path: 'pharmacy-product-list',
    loadComponent: () => import('./pharmacy/pharmacy-product-list/pharmacy-product-list.page').then(m => m.PharmacyProductListPage)
  },
  {
    path: 'animal-share-list',
    loadComponent: () => import('./animal/animal-share-list/animal-share-list.page').then(m => m.AnimalShareListPage)
  },
  {
    path: 'animal-share-update',
    loadComponent: () => import('./animal/animal-share-update/animal-share-update.page').then(m => m.AnimalShareUpdatePage)
  },
  {
    path: 'animal-share-update/:animalShareId',
    loadComponent: () => import('./animal/animal-share-update/animal-share-update.page').then(m => m.AnimalShareUpdatePage)
  },
  {
    path: 'animal-sharewithme-update/:animalShareId',
    loadComponent: () => import('./animal/animal-sharewithme-update/animal-sharewithme-update.page').then(m => m.AnimalSharewithmeUpdatePage)
  },
  {
    path: 'organization-member-list',
    loadComponent: () => import('./organization/organization-member-list/organization-member-list.page').then(m => m.OrganizationMemberListPage)
  },
  {
    path: 'organization-member-update',
    loadComponent: () => import('./organization/organization-member-update/organization-member-update.page').then(m => m.OrganizationMemberUpdatePage)
  },
  {
    path: 'organization-member-update/:organizationMemberId',
    loadComponent: () => import('./organization/organization-member-update/organization-member-update.page').then(m => m.OrganizationMemberUpdatePage)
  },
  {
    path: 'plan',
    loadComponent: () => import('./map/plan/plan.page').then(m => m.PlanPage)
  },
  {
    path: 'plan/:action/:mapPlanItemId',
    loadComponent: () => import('./map/plan/plan.page').then(m => m.PlanPage)
  },
  {
    path: 'organization-update',
    loadComponent: () => import('./organization/organization-update/organization-update.page').then(m => m.OrganizationUpdatePage)
  },
  {
    path: 'organization-add',
    loadComponent: () => import('./organization/organization-add/organization-add.page').then(m => m.OrganizationAddPage)
  },
  {
    path: 'organization-fiche',
    loadComponent: () => import('./organization/organization-fiche/organization-fiche.page').then(m => m.OrganizationFichePage)
  },
  {
    path: 'organization-documents',
    loadComponent: () => import('./organization/organization-documents/organization-documents.page').then(m => m.OrganizationDocumentsPage)
  },
  {
    path: 'organization-public-animals/:organizationId',
    loadComponent: () => import('./organization/public/organization-public-animals/organization-public-animals.page').then(m => m.OrganizationPublicAnimalsPage)
  },
  {
    path: 'organization-public-animals/:organizationId/:animalId',
    loadComponent: () => import('./organization/public/organization-public-animals/organization-public-animals.page').then(m => m.OrganizationPublicAnimalsPage)
  },
  {
    path: 'animal-owner/:animalId',
    loadComponent: () => import('./animal/animal-owner/animal-owner.page').then(m => m.AnimalOwnerPage)
  },
  {
    path: 'organization-fosterfamily-list',
    loadComponent: () => import('./organization/organization-fosterfamily-list/organization-fosterfamily-list.page').then(m => m.OrganizationFosterfamilyListPage)
  },
  {
    path: 'organization-fosterfamily-update',
    loadComponent: () => import('./organization/organization-fosterfamily-update/organization-fosterfamily-update.page').then(m => m.OrganizationFosterfamilyUpdatePage)
  },
  {
    path: 'organization-fosterfamily-update/:fosterFamilyId',
    loadComponent: () => import('./organization/organization-fosterfamily-update/organization-fosterfamily-update.page').then(m => m.OrganizationFosterfamilyUpdatePage)
  },
  {
    path: 'organization-flowcontrol',
    loadComponent: () => import('./organization/organization-flowcontrol/organization-flowcontrol.page').then(m => m.OrganizationFlowcontrolPage)
  },
  {
    path: 'organization-flowcontrol/:set/:animalId',
    loadComponent: () => import('./organization/organization-flowcontrol/organization-flowcontrol.page').then(m => m.OrganizationFlowcontrolPage)
  },
  {
    path: 'organization-walking',
    loadComponent: () => import('./organization/organization-walking/organization-walking.page').then(m => m.OrganizationWalkingPage)
  },
  {
    path: 'organization-stats',
    loadComponent: () => import('./organization/organization-stats/organization-stats.page').then(m => m.OrganizationStatsPage)
  },
  {
    path: 'compta-invoices-list',
    loadComponent: () => import('./compta/invoices-list/invoices-list.page').then(m => m.InvoicesListPage)
  },
  {
    path: 'compta-invoices-list/:add',
    loadComponent: () => import('./compta/invoices-list/invoices-list.page').then(m => m.InvoicesListPage)
  },
  {
    path: 'compta-invoices-list/:add/:fromPhoto',
    loadComponent: () => import('./compta/invoices-list/invoices-list.page').then(m => m.InvoicesListPage)
  },
  {
    path: 'discussion-list',
    loadComponent: () => import('./discussion/discussion-list/discussion-list.page').then(m => m.DiscussionListPage)
  },
  {
    path: 'discussion-new/:userId',
    loadComponent: () => import('./discussion/discussion-new/discussion-new.page').then(m => m.DiscussionNewPage)
  },
  {
    path: 'discussion-new',
    loadComponent: () => import('./discussion/discussion-new/discussion-new.page').then(m => m.DiscussionNewPage)
  },
  {
    path: 'discussion-pool-edit/:discussionId',
    loadComponent: () => import('./discussion/discussion-pool-edit/discussion-pool-edit.page').then(m => m.DiscussionPoolEditPage)
  },
  {
    path: 'discussion-pool-edit/:discussionId/:poolId',
    loadComponent: () => import('./discussion/discussion-pool-edit/discussion-pool-edit.page').then(m => m.DiscussionPoolEditPage)
  },
  {
    path: 'discussion-post/:discussionId',
    loadComponent: () => import('./discussion/discussion-post/discussion-post.page').then(m => m.DiscussionPostPage)
  },
  {
    path: 'user-profil-public-animals/:userIdentifier',
    loadComponent: () => import('./userProfile/user-profil-public-animals/user-profil-public-animals.page').then(m => m.UserProfilPublicAnimalsPage)
  },
  {
    path: 'redirect-to-store',
    loadComponent: () => import('./redirect-to-store/redirect-to-store.page').then(m => m.RedirectToStorePage)
  },
  {
    path: 'telechargez-lapplication',
    loadComponent: () => import('./redirect-to-store/redirect-to-store.page').then(m => m.RedirectToStorePage)
  },
  {
    path: 'download',
    loadComponent: () => import('./redirect-to-store/redirect-to-store.page').then(m => m.RedirectToStorePage)
  },
  {
    path: 'animal-death/:animalId',
    loadComponent: () => import('./animal/animal-death/animal-death.page').then(m => m.AnimalDeathPage)
  },
  {
    path: 'organization-subscription',
    loadComponent: () => import('./organization/organization-subscription/organization-subscription.page').then(m => m.OrganizationSubscriptionPage)
  },
  {
    path: 'litter-list',
    loadComponent: () => import('./litter/litter-list/litter-list.page').then(m => m.LitterListPage)
  },
  {
    path: 'litter-update',
    loadComponent: () => import('./litter/litter-update/litter-update.page').then(m => m.LitterUpdatePage)
  },
  {
    path: 'litter-update/:litterId',
    loadComponent: () => import('./litter/litter-update/litter-update.page').then(m => m.LitterUpdatePage)
  },
  {
    path: 'litter-fiche/:litterId',
    loadComponent: () => import('./litter/litter-fiche/litter-fiche.page').then(m => m.LitterFichePage)
  },
  {
    path: 'logbook',
    loadComponent: () => import('./logbook/logbook.page').then(m => m.LogbookPage)
  },
  {
    path: 'logbook/:segment',
    loadComponent: () => import('./logbook/logbook.page').then(m => m.LogbookPage)
  },
  {
    path: 'logbook/:segment/:postId',
    loadComponent: () => import('./logbook/logbook.page').then(m => m.LogbookPage)
  },
  {
    path: 'load-score-history/:animalId',
    loadComponent: () => import('./loadScore/load-score-history/load-score-history.page').then(m => m.LoadScoreHistoryPage)
  },
  {
    path: 'load-score-record/:animalId',
    loadComponent: () => import('./loadScore/load-score-record/load-score-record.page').then(m => m.LoadScoreRecordPage)
  },
  {
    path: 'kibblechat',
    loadComponent: () => import('./kibblechat/kibblechat.page').then(m => m.KibbleChatPage)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.page').then(m => m.DashboardPage),
    canActivate: [() => import('./services/superuser.guard').then(m => m.superuserGuard)]
  },
  {
    path: 'newsletter-list',
    loadComponent: () => import('./newsletter/newsletter-list/newsletter-list.page').then(m => m.NewsletterListPage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'newsletter-stats/:newsletterId',
    loadComponent: () => import('./newsletter/newsletter-stats/newsletter-stats.page').then(m => m.NewsletterStatsPage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'newsletter-update',
    loadComponent: () => import('./newsletter/newsletter-update/newsletter-update.page').then(m => m.NewsletterUpdatePage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'newsletter-update/:newsletterId',
    loadComponent: () => import('./newsletter/newsletter-update/newsletter-update.page').then(m => m.NewsletterUpdatePage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'template-list',
    loadComponent: () => import('./newsletter/template-list/template-list.page').then(m => m.TemplateListPage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'template-update',
    loadComponent: () => import('./newsletter/template-update/template-update.page').then(m => m.TemplateUpdatePage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'template-update/:templateId',
    loadComponent: () => import('./newsletter/template-update/template-update.page').then(m => m.TemplateUpdatePage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'recipient-list-list',
    loadComponent: () => import('./newsletter/recipient-list-list/recipient-list-list.page').then(m => m.RecipientListListPage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'recipient-list-detail/:recipientListId',
    loadComponent: () => import('./newsletter/recipient-list-detail/recipient-list-detail.page').then(m => m.RecipientListDetailPage),
    canActivate: [() => import('./services/staff.guard').then(m => m.staffGuard)]
  },
  {
    path: 'animal-birthday/:animalId',
    loadComponent: () => import('./animal/animal-birthday/animal-birthday.page').then(m => m.AnimalBirthdayPage)
  },
];
